angular.module('app.localize', [])
    
    .factory('localize', ['$http', '$rootScope', '$window', function ($http, $rootScope, $window) {
        var localize = {
            currentLocaleData: {},
            currentLang: {},
            setLang: function (lang) {
                $http({method: 'GET', url: localize.getLangUrl(lang), cache: false})
                    .then(function (response) {
                        localize.currentLocaleData = response.data;
                        localize.currentLang = lang;
                        $rootScope.$broadcast('localizeLanguageChanged');
                    });
            },
            getLangUrl: function (lang) {
                if(typeof lang === "undefined"){
                    lang = "en";
                }
                return 'ms/v2/languages.bto?lang=' + lang;
            },
            
            localizeText: function (sourceText) {
                return localize.currentLocaleData[sourceText];
            }
        };
        
        return localize;
    }])
    
    .directive('localize', ['localize', '$compile', function (localize, $compile) {
        return {
            restrict: 'A',
            scope: {
                sourceText: '@localize'
            },
            link: function (scope, element, attrs) {
                const localizedText = localize.localizeText(scope.sourceText);
                if(typeof localizedText === "undefined"){
                    return;
                }
                if (typeof element.children()[0] === "undefined") {
                    return element.text(localizedText);
                }
                
                if (element.is('input, textarea')){
                    element.attr('placeholder', localizedText);
                } else {
                    // console.log(element.contents());
                    // console.log(element.html());
                    // console.log(element.children()[1]);
                    const childEl = element.children()[0].className;
                    // console.log(childEl);
                    // element.removeText();
                    // element.append(`<i class=${childEl}/>${localizedText}`);
                    // element.html(childEl + localizedText);
                    // element.text(localizedText);
                    // element.append(`<i class="${childEl}"/>`);
                    element.text('');
                    element.append(`<i class="${childEl}"/>${localizedText}`);
                    
                }
            }
        };
    }]);

export default angular.module('app.controllers', [])
    .factory('settings', ['$rootScope', function ($rootScope) {
        // supported languages
        
        var settings = {
            languages: [
                {
                    language: 'English',
                    translation: 'English',
                    langCode: 'en',
                    flagCode: 'us'
                },
                {
                    language: 'Hindi',
                    translation: 'हिंदी',
                    langCode: 'hi',
                    flagCode: 'hi'
                },
                //{
                //    language: 'German',
                //    translation: 'Deutsch',
                //    langCode: 'de',
                //    flagCode: 'de'
                //},
                //{
                //    language: 'Korean',
                //    translation: '한국의',
                //    langCode: 'ko',
                //    flagCode: 'kr'
                //},
                {
                    language: 'French',
                    translation: 'français',
                    langCode: 'fr',
                    flagCode: 'fr'
                },
                //{
                //    language: 'Portuguese',
                //    translation: 'português',
                //    langCode: 'pt',
                //    flagCode: 'br'
                //},
                //{
                //    language: 'Russian',
                //    translation: 'русский',
                //    langCode: 'ru',
                //    flagCode: 'ru'
                //},
                //{
                //    language: 'Chinese',
                //    translation: '中國的',
                //    langCode: 'zh',
                //    flagCode: 'cn'
                //}
            ],
            
        };
        
        return settings;
        
    }])
    .controller('LangController', ['$scope', 'settings', 'localize', function ($scope, settings, localize) {
        $scope.languages = settings.languages;
        $scope.currentLang = settings.currentLang;
        $scope.setLang = function (lang) {
            settings.currentLang = lang;
            $scope.currentLang = lang;
            localize.setLang(lang);
        };
        
        // set the default language
        $scope.setLang($scope.currentLang);
        
    }]);

angular.module('app.main', [])
    // initiate body
    // .directive('body', function () {
    //     return {
    //         restrict: 'E',
    //         link: function (scope, element, attrs) {
    //             element.on('click', 'a[href="#"], [data-toggle]', function (e) {
    //                 e.preventDefault();
    //             });
    //         }
    //     };
    // })
    
    .factory('ribbon', ['$rootScope', function ($rootScope) {
        var ribbon = {
            currentBreadcrumb: [],
            updateBreadcrumb: function (crumbs) {
                //crumbs.push('');
                var breadCrumb = crumbs.reverse();
                ribbon.currentBreadcrumb = breadCrumb;
                $rootScope.$broadcast('navItemSelected', breadCrumb);
            }
        };
        
        return ribbon;
    }])
    
    .directive('action', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                /*
                 * SMART ACTIONS
                 */
                var smartActions = {
                    
                    // LOGOUT MSG
                    userLogout: function ($this) {
                        
                        // ask verification
                        $.SmartMessageBox({
                            title: "<i class='fa fa-sign-out txt-color-orangeDark'></i> Logout <span class='txt-color-orangeDark'><strong>" + $('#show-shortcut').text() + "</strong></span> ?",
                            content: $this.data('logout-msg') || "You can improve your security further after logging out by closing this opened browser",
                            buttons: '[No][Yes]'
                            
                        }, function (ButtonPressed) {
                            if (ButtonPressed == "Yes") {
                                //$.root_.addClass('animated fadeOutUp');
                                setTimeout(logout, 1000);
                            }
                        });
                        
                        function logout() {
                            window.location = $this.attr('href');
                        }
                        
                    },
                    
                    // RESET WIDGETS
                    resetWidgets: function ($this) {
                        $.widresetMSG = $this.data('reset-msg');
                        
                        $.SmartMessageBox({
                            title: "<i class='fa fa-refresh' style='color:green'></i> Clear Local Storage",
                            content: $.widresetMSG || "Would you like to RESET all your saved widgets and clear LocalStorage?",
                            buttons: '[No][Yes]'
                        }, function (ButtonPressed) {
                            if (ButtonPressed == "Yes" && localStorage) {
                                localStorage.clear();
                                location.reload();
                            }
                            
                        });
                    },
                    
                    // LAUNCH FULLSCREEN
                    launchFullscreen: function (element) {
                        
                        if (!$.root_.hasClass("full-screen")) {
                            
                            $.root_.addClass("full-screen");
                            
                            if (element.requestFullscreen) {
                                element.requestFullscreen();
                            } else if (element.mozRequestFullScreen) {
                                element.mozRequestFullScreen();
                            } else if (element.webkitRequestFullscreen) {
                                element.webkitRequestFullscreen();
                            } else if (element.msRequestFullscreen) {
                                element.msRequestFullscreen();
                            }
                            
                        } else {
                            
                            $.root_.removeClass("full-screen");
                            
                            if (document.exitFullscreen) {
                                document.exitFullscreen();
                            } else if (document.mozCancelFullScreen) {
                                document.mozCancelFullScreen();
                            } else if (document.webkitExitFullscreen) {
                                document.webkitExitFullscreen();
                            }
                            
                        }
                        
                    },
                    
                    // MINIFY MENU
                    minifyMenu: function ($this) {
                        if (!$.root_.hasClass("menu-on-top")) {
                            $.root_.toggleClass("minified");
                            $.root_.removeClass("hidden-menu");
                            $('html').removeClass("hidden-menu-mobile-lock");
                            $this.effect("highlight", {}, 500);
                        }
                    },
                    
                    // TOGGLE SHORTCUT
                    toggleShortcut: function () {
                        
                        if (shortcut_dropdown.is(":visible")) {
                            shortcut_buttons_hide();
                        } else {
                            shortcut_buttons_show();
                        }
                        
                        // SHORT CUT (buttons that appear when clicked on user name)
                        shortcut_dropdown.find('a').click(function (e) {
                            e.preventDefault();
                            window.location = $(this).attr('href');
                            setTimeout(shortcut_buttons_hide, 300);
                            
                        });
                        
                        // SHORTCUT buttons goes away if mouse is clicked outside of the area
                        $(document).mouseup(function (e) {
                            if (!shortcut_dropdown.is(e.target) && shortcut_dropdown.has(e.target).length === 0) {
                                shortcut_buttons_hide();
                            }
                        });
                        
                        // SHORTCUT ANIMATE HIDE
                        function shortcut_buttons_hide() {
                            shortcut_dropdown.animate({
                                height: "hide"
                            }, 300, "easeOutCirc");
                            $.root_.removeClass('shortcut-on');
                            
                        }
                        
                        // SHORTCUT ANIMATE SHOW
                        function shortcut_buttons_show() {
                            shortcut_dropdown.animate({
                                height: "show"
                            }, 200, "easeOutCirc");
                            $.root_.addClass('shortcut-on');
                        }
                        
                    }
                    
                };
                
                var actionEvents = {
                    userLogout: function (e) {
                        smartActions.userLogout(element);
                    },
                    resetWidgets: function (e) {
                        smartActions.resetWidgets(element);
                    },
                    launchFullscreen: function (e) {
                        smartActions.launchFullscreen(document.documentElement);
                    },
                    minifyMenu: function (e) {
                        smartActions.minifyMenu(element);
                    },
                    toggleMenu: function (e) {
                        smartActions.toggleMenu();
                    },
                    toggleShortcut: function (e) {
                        smartActions.toggleShortcut();
                    }
                };
                
                if (angular.isDefined(attrs.action) && attrs.action != '') {
                    var actionEvent = actionEvents[attrs.action];
                    if (typeof actionEvent === 'function') {
                        element.on('click', function (e) {
                            actionEvent(e);
                            e.preventDefault();
                        });
                    }
                }
                
            }
        };
    })
    
    .directive('header', function () {
        return {
            restrict: 'EA',
            link: function (scope, element, attrs) {
                // SHOW & HIDE MOBILE SEARCH FIELD
                angular.element('#search-mobile').click(function () {
                    $.root_.addClass('search-mobile');
                });
                
                angular.element('#cancel-search-js').click(function () {
                    $.root_.removeClass('search-mobile');
                });
            }
        };
    })
    
    .directive('ribbon', function () {
        return {
            restrict: 'A',
            transclude: true,
            replace: true,
            template: '<ng-transclude></ng-transclude>',
            link: function (scope, element, attrs) {
                //element.append('<ng-transclude></ng-transclude>')
                //element.append('<chat-users></chat-users>');
                // hide bg options
                var smartbgimage = "<h6 class='margin-top-10 semi-bold'>Background</h6><img src='/assets/img/pattern/graphy-xs.png' data-htmlbg-url='/assets/img/pattern/graphy.png' width='22' height='22' class='margin-right-5 bordered cursor-pointer'><img src='/assets/img/pattern/tileable_wood_texture-xs.png' width='22' height='22' data-htmlbg-url='/assets/img/pattern/tileable_wood_texture.png' class='margin-right-5 bordered cursor-pointer'><img src='/assets/img/pattern/sneaker_mesh_fabric-xs.png' width='22' height='22' data-htmlbg-url='/assets/img/pattern/sneaker_mesh_fabric.png' class='margin-right-5 bordered cursor-pointer'><img src='/assets/img/pattern/nistri-xs.png' data-htmlbg-url='/assets/img/pattern/nistri.png' width='22' height='22' class='margin-right-5 bordered cursor-pointer'><img src='/assets/img/pattern/paper-xs.png' data-htmlbg-url='/assets/img/pattern/paper.png' width='22' height='22' class='bordered cursor-pointer'>";
                $("#smart-bgimages")
                    .fadeOut();
                
                $('#demo-setting')
                    .click(function () {
                        ////console.log('setting');
                        $('#ribbon .demo')
                            .toggleClass('activate');
                    });
                /*
                 * FIXED HEADER
                 */
                $('input[type="checkbox"]#smart-fixed-header')
                    .click(function () {
                        if ($(this)
                            .is(':checked')) {
                            //checked
                            $.root_.addClass("fixed-header");
                        } else {
                            //unchecked
                            $('input[type="checkbox"]#smart-fixed-ribbon')
                                .prop('checked', false);
                            $('input[type="checkbox"]#smart-fixed-navigation')
                                .prop('checked', false);
                            
                            $.root_.removeClass("fixed-header");
                            $.root_.removeClass("fixed-navigation");
                            $.root_.removeClass("fixed-ribbon");
                            
                        }
                    });
                
                /*
                 * FIXED NAV
                 */
                $('input[type="checkbox"]#smart-fixed-navigation')
                    .click(function () {
                        if ($(this)
                            .is(':checked')) {
                            //checked
                            $('input[type="checkbox"]#smart-fixed-header')
                                .prop('checked', true);
                            
                            $.root_.addClass("fixed-header");
                            $.root_.addClass("fixed-navigation");
                            
                            $('input[type="checkbox"]#smart-fixed-container')
                                .prop('checked', false);
                            $.root_.removeClass("container");
                            
                        } else {
                            //unchecked
                            $('input[type="checkbox"]#smart-fixed-ribbon')
                                .prop('checked', false);
                            $.root_.removeClass("fixed-navigation");
                            $.root_.removeClass("fixed-ribbon");
                        }
                    });
                
                /*
                 * FIXED RIBBON
                 */
                $('input[type="checkbox"]#smart-fixed-ribbon')
                    .click(function () {
                        if ($(this)
                            .is(':checked')) {
                            
                            //checked
                            $('input[type="checkbox"]#smart-fixed-header')
                                .prop('checked', true);
                            $('input[type="checkbox"]#smart-fixed-navigation')
                                .prop('checked', true);
                            $('input[type="checkbox"]#smart-fixed-ribbon')
                                .prop('checked', true);
                            
                            //apply
                            $.root_.addClass("fixed-header");
                            $.root_.addClass("fixed-navigation");
                            $.root_.addClass("fixed-ribbon");
                            
                            $('input[type="checkbox"]#smart-fixed-container')
                                .prop('checked', false);
                            $.root_.removeClass("container");
                            
                        } else {
                            //unchecked
                            $.root_.removeClass("fixed-ribbon");
                        }
                    });
                
                /*
                 * RTL SUPPORT
                 */
                $('input[type="checkbox"]#smart-fixed-footer')
                    .click(function () {
                        if ($(this)
                            .is(':checked')) {
                            
                            //checked
                            $.root_.addClass("fixed-page-footer");
                            
                        } else {
                            //unchecked
                            $.root_.removeClass("fixed-page-footer");
                        }
                    });
                
                
                /*
                 * RTL SUPPORT
                 */
                $('input[type="checkbox"]#smart-rtl')
                    .click(function () {
                        if ($(this)
                            .is(':checked')) {
                            
                            //checked
                            $.root_.addClass("smart-rtl");
                            
                        } else {
                            //unchecked
                            $.root_.removeClass("smart-rtl");
                        }
                    });
                
                /*
                 * MENU ON TOP
                 */
                
                $('#smart-topmenu')
                    .on('change', function (e) {
                        if ($(this)
                            .prop('checked')) {
                            //window.location.href = '?menu=top';
                            localStorage.setItem('sm-setmenu', 'top');
                            location.reload();
                        } else {
                            //window.location.href = '?';
                            localStorage.setItem('sm-setmenu', 'left');
                            location.reload();
                        }
                    });
                
                if (localStorage.getItem('sm-setmenu') == 'top') {
                    $('#smart-topmenu')
                        .prop('checked', true);
                } else {
                    $('#smart-topmenu')
                        .prop('checked', false);
                }
                
                /*
                 * INSIDE CONTAINER
                 */
                $('input[type="checkbox"]#smart-fixed-container')
                    .click(function () {
                        if ($(this)
                            .is(':checked')) {
                            //checked
                            $.root_.addClass("container");
                            
                            $('input[type="checkbox"]#smart-fixed-ribbon')
                                .prop('checked', false);
                            $.root_.removeClass("fixed-ribbon");
                            
                            $('input[type="checkbox"]#smart-fixed-navigation')
                                .prop('checked', false);
                            $.root_.removeClass("fixed-navigation");
                            
                            if (smartbgimage) {
                                $("#smart-bgimages")
                                    .append(smartbgimage)
                                    .fadeIn(1000);
                                $("#smart-bgimages img")
                                    .bind("click", function () {
                                        var $this = $(this);
                                        var $html = $('html');
                                        bgurl = ($this.data("htmlbg-url"));
                                        $html.css("background-image", "url(" + bgurl + ")");
                                    });
                                smartbgimage = null;
                            } else {
                                $("#smart-bgimages")
                                    .fadeIn(1000);
                            }
                            
                        } else {
                            //unchecked
                            $.root_.removeClass("container");
                            $("#smart-bgimages")
                                .fadeOut();
                        }
                    });
                
                /*
                 * REFRESH WIDGET
                 */
                $("#reset-smart-widget")
                    .bind("click", function () {
                        $('#refresh')
                            .click();
                        return false;
                    });
                
                /*
                 * STYLES
                 */
                $("#smart-styles > a")
                    .on('click', function () {
                        var $this = $(this);
                        var $logo = $("#logo img");
                        $.root_.removeClassPrefix('smart-style')
                            .addClass($this.attr("id"));
                        $logo.attr('src', $this.data("skinlogo"));
                        $("#smart-styles > a #skin-checked")
                            .remove();
                        $this.prepend("<i class='fa fa-check fa-fw' id='skin-checked'></i>");
                    });
            }
        };
    })
    
    .controller('breadcrumbController', ['$scope', function ($scope) {
        $scope.breadcrumbs = [];
        $scope.$on('navItemSelected', function (name, crumbs) {
            $scope.setBreadcrumb(crumbs);
        });
        
        $scope.setBreadcrumb = function (crumbs) {
            $scope.breadcrumbs = crumbs;
        };
    }])
    
    .directive('breadcrumb1', ['ribbon', 'localize', '$compile', function (ribbon, localize, $compile) {
        return {
            restrict: 'AE',
            controller: 'breadcrumbController',
            replace: true,
            link: function (scope, element, attrs) {
                scope.$watch('breadcrumbs', function (newVal, oldVal) {
                    if (newVal !== oldVal) {
                        // update DOM
                        scope.updateDOM();
                    }
                });
                scope.updateDOM = function () {
                    element.empty();
                    angular.forEach(scope.breadcrumbs, function (crumb) {
                        //console.log(crumb);
                        var li = "";
                        if (crumb === 'Home') {
                            li = angular.element('<li data-localize="' + crumb + '"><i class="fa-fw fa fa-home">' + crumb + '</i></li>');
                            li.text(localize.localizeText(crumb));
                            
                            
                        } else {
                            li = angular.element('<li data-localize="' + crumb + '">' + crumb + '</li>');
                            li.text(localize.localizeText(crumb));
                            
                            //$compile(li)(scope);
                            //element.append(li);
                        }
                        
                        $compile(li)(scope);
                        element.append(li);
                        
                    });
                };
                
                // set the current breadcrumb on load
                scope.setBreadcrumb(ribbon.currentBreadcrumb);
                scope.updateDOM();
            },
            template: '<ol class="breadcrumb"></ol>'
        };
    }]);

angular.module('app.activity', [])
    .controller('ActivityController', ['$scope', '$http', function ($scope, $http) {
        var ctrl = this,
            items = ctrl.items = $scope.items = [];
        
        ctrl.loadItem = function (loadedItem, callback) {
            angular.forEach(items, function (item) {
                if (item.active && item !== loadedItem) {
                    item.active = false;
                    //item.onDeselect();
                }
            });
            
            loadedItem.active = true;
            if (angular.isDefined(loadedItem.onLoad)) {
                loadedItem.onLoad(loadedItem);
            }
            
            $http.get(loadedItem.src).then(function (result) {
                var content = result.data;
                if (angular.isDefined(callback)) {
                    callback(content);
                }
            });
        };
        
        ctrl.addItem = function (item) {
            items.push(item);
            if (!angular.isDefined(item.active)) {
                // set the default
                item.active = false;
            } else if (item.active) {
                ctrl.loadItem(item);
            }
        };
        
        ctrl.refresh = function (e) {
            var btn = angular.element(e.currentTarget);
            btn.button('loading');
            
            if (angular.isDefined($scope.onRefresh)) {
                $scope.onRefresh($scope, function () {
                    btn.button('reset');
                });
            } else {
                btn.button('reset');
            }
        };
    }])
    
    .directive('activity', function () {
        return {
            restrict: 'AE',
            replace: true,
            transclude: true,
            controller: 'ActivityController',
            scope: {
                onRefresh: '=onrefresh',
            },
            template: '<span data-ng-transclude=""></span>'
        };
    })
    
    .directive('activityButton', function () {
        return {
            restrict: 'AE',
            require: '^activity',
            replace: true,
            transclude: true,
            controller: function () {
            
            },
            scope: {
                icon: '@',
                total: '='
            },
            template: '\
                    <span id="activity" class="activity-dropdown">\
                        <i ng-class="icon"></i>\
                        <b class="badge"> {{ total }} </b>\
                    </span>',
            link: function (scope, element, attrs, activityCtrl) {
                
                attrs.$observe('icon', function (value) {
                    if (!angular.isDefined(value))
                        scope.icon = 'fa fa-user';
                });
                
                element.on('click', function (e) {
                    var $this = $(this);
                    
                    if ($this.find('.badge').hasClass('bg-color-red')) {
                        $this.find('.badge').removeClassPrefix('bg-color-');
                        $this.find('.badge').text("0");
                        // //console.log("Ajax call for activity")
                    }
                    
                    if (!$this.next('.ajax-dropdown').is(':visible')) {
                        $this.next('.ajax-dropdown').fadeIn(150);
                        $this.addClass('active');
                    } else {
                        $this.next('.ajax-dropdown').fadeOut(150);
                        $this.removeClass('active');
                    }
                    
                    var mytest = $this.next('.ajax-dropdown').find('.btn-group > .active > input').attr('id');
                    ////console.log(mytest)
                    
                    e.preventDefault();
                });
                
                if (scope.total > 0) {
                    var $badge = element.find('.badge');
                    $badge.addClass("bg-color-red bounceIn animated");
                }
            }
        };
    })
    
    .controller('ActivityContentController', ['$scope', function ($scope) {
        var ctrl = this;
        $scope.currentContent = '';
        ctrl.loadContent = function (content) {
            $scope.currentContent = content;
        };
    }])
    
    .directive('activityContent', ['$compile', function ($compile) {
        return {
            restrict: 'AE',
            transclude: true,
            require: '^activity',
            replace: true,
            scope: {
                footer: '=?'
            },
            controller: 'ActivityContentController',
            template: '\
                <div class="ajax-dropdown">\
                    <div class="btn-group btn-group-justified" data-toggle="buttons" data-ng-transclude=""></div>\
                    <div class="ajax-notifications custom-scroll">\
                        <div class="alert alert-transparent">\
                            <h4>Click a button to show messages here</h4>\
                            This blank page message helps protect your privacy, or you can show the first message here automatically.\
                        </div>\
                        <i class="fa fa-lock fa-4x fa-border"></i>\
                    </div>\
                    <span> {{ footer }}\
                        <button type="button" data-loading-text="Loading..." data-ng-click="refresh($event)" class="btn btn-xs btn-default pull-right" data-activty-refresh-button="">\
                        <i class="fa fa-refresh"></i>\
                        </button>\
                    </span>\
                </div>',
            link: function (scope, element, attrs, activityCtrl) {
                scope.refresh = function (e) {
                    activityCtrl.refresh(e);
                };
                
                scope.$watch('currentContent', function (newContent, oldContent) {
                    if (newContent !== oldContent) {
                        var el = element.find('.ajax-notifications').html(newContent);
                        $compile(el)(scope);
                    }
                });
            }
        };
    }])
    
    .directive('activityItem', function () {
        return {
            restrict: 'AE',
            require: ['^activity', '^activityContent'],
            scope: {
                src: '=',
                onLoad: '=onload',
                active: '=?'
            },
            controller: function () {
            
            },
            transclude: true,
            replace: true,
            template: '\
                <label class="btn btn-default" data-ng-click="loadItem()" ng-class="{active: active}">\
                    <input type="radio" name="activity">\
                    <span data-ng-transclude=""></span>\
                </label>',
            link: function (scope, element, attrs, parentCtrls) {
                var activityCtrl = parentCtrls[0],
                    contentCtrl = parentCtrls[1];
                
                scope.$watch('active', function (active) {
                    if (active) {
                        activityCtrl.loadItem(scope, function (content) {
                            contentCtrl.loadContent(content);
                        });
                    }
                });
                activityCtrl.addItem(scope);
                
                scope.loadItem = function () {
                    scope.active = true;
                };
            }
        };
    });

angular.module('app.demoControllers', [])
    .controller('WidgetDemoCtrl', ['$scope', '$sce', function ($scope, $sce) {
        $scope.title = 'SmartUI Widget';
        $scope.icon = 'fa fa-user';
        $scope.toolbars = [
            $sce.trustAsHtml('<div class="label label-success">\
                <i class="fa fa-arrow-up"></i> 2.35%\
            </div>'),
            $sce.trustAsHtml('<div class="btn-group" data-toggle="buttons">\
                <label class="btn btn-default btn-xs active">\
                  <input type="radio" name="style-a1" id="style-a1"> <i class="fa fa-play"></i>\
                </label>\
                <label class="btn btn-default btn-xs">\
                  <input type="radio" name="style-a2" id="style-a2"> <i class="fa fa-pause"></i>\
                </label>\
                <label class="btn btn-default btn-xs">\
                  <input type="radio" name="style-a2" id="style-a3"> <i class="fa fa-stop"></i>\
                </label>\
            </div>')
        ];
        
        $scope.content = $sce.trustAsHtml('\
                        Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\
                        tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\
                        quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\
                        consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\
                        cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\
                        proident, sunt in culpa qui officia deserunt mollit anim id est laborum.');
    }])
    
    .controller('ActivityDemoCtrl', ['$scope', function ($scope) {
        var ctrl = this;
        ctrl.getDate = function () {
            return new Date().toUTCString();
        };
        
        $scope.refreshCallback = function (contentScope, done) {
            
            // use contentScope to get access with activityContent directive's Control Scope
            //console.log(contentScope);
            
            // for example getting your very long data ...........
            setTimeout(function () {
                done();
            }, 3000);
            
            $scope.footerContent = ctrl.getDate();
        };
        
        $scope.items = [
            {
                title: 'Msgs',
                count: 14,
                src: '/assets/ajax/notify/mail.html',
                onload: function (item) {
                    //console.log(item);
                    alert('[Callback] Loading Messages ...');
                }
            },
            {
                title: 'Notify',
                count: 3,
                src: '/assets/ajax/notify/notifications.html'
            },
            {
                title: 'Tasks',
                count: 4,
                src: '/assets/ajax/notify/tasks.html',
                //active: true
            }
        ];
        
        $scope.total = 0;
        angular.forEach($scope.items, function (item) {
            $scope.total += item.count;
        });
        
        $scope.footerContent = ctrl.getDate();
        
    }]);
